/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Mostplayed1Inputs */

const id_nav_mostplayed1 = /** @type {(inputs: Nav_Mostplayed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paling banyak dimainkan`)
};

const ms_nav_mostplayed1 = /** @type {(inputs: Nav_Mostplayed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paling banyak dimainkan`)
};

const da_nav_mostplayed1 = /** @type {(inputs: Nav_Mostplayed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mest spillede`)
};

const de_nav_mostplayed1 = /** @type {(inputs: Nav_Mostplayed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meistgespielt`)
};

const en_us2_nav_mostplayed1 = /** @type {(inputs: Nav_Mostplayed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Most Played`)
};

const es_es2_nav_mostplayed1 = /** @type {(inputs: Nav_Mostplayed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más jugados`)
};

const es_mx2_nav_mostplayed1 = /** @type {(inputs: Nav_Mostplayed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más jugados`)
};

const fil_nav_mostplayed1 = /** @type {(inputs: Nav_Mostplayed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pinakamalaro`)
};

const fr_nav_mostplayed1 = /** @type {(inputs: Nav_Mostplayed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les plus joués`)
};

const it_nav_mostplayed1 = /** @type {(inputs: Nav_Mostplayed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Più giocati`)
};

const hu_nav_mostplayed1 = /** @type {(inputs: Nav_Mostplayed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legtöbbet játszottak`)
};

const nl_nav_mostplayed1 = /** @type {(inputs: Nav_Mostplayed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meest gespeeld`)
};

const no_nav_mostplayed1 = /** @type {(inputs: Nav_Mostplayed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mest spilte`)
};

const pl_nav_mostplayed1 = /** @type {(inputs: Nav_Mostplayed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najczęściej grane`)
};

const pt_br2_nav_mostplayed1 = /** @type {(inputs: Nav_Mostplayed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais jogados`)
};

const pt_nav_mostplayed1 = /** @type {(inputs: Nav_Mostplayed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais jogados`)
};

const ro_nav_mostplayed1 = /** @type {(inputs: Nav_Mostplayed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cel mai jucate`)
};

const fi_nav_mostplayed1 = /** @type {(inputs: Nav_Mostplayed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelatuimmat`)
};

const sv_nav_mostplayed1 = /** @type {(inputs: Nav_Mostplayed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mest spelade`)
};

const vi_nav_mostplayed1 = /** @type {(inputs: Nav_Mostplayed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chơi nhiều nhất`)
};

const tr_nav_mostplayed1 = /** @type {(inputs: Nav_Mostplayed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En Çok Oynananlar`)
};

const cs_nav_mostplayed1 = /** @type {(inputs: Nav_Mostplayed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejhranější`)
};

const bg_nav_mostplayed1 = /** @type {(inputs: Nav_Mostplayed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Най-играни`)
};

const ru_nav_mostplayed1 = /** @type {(inputs: Nav_Mostplayed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Самые популярные`)
};

const uk_nav_mostplayed1 = /** @type {(inputs: Nav_Mostplayed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Найпопулярніші`)
};

const ar_nav_mostplayed1 = /** @type {(inputs: Nav_Mostplayed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأكثر لعبًا`)
};

const hi_nav_mostplayed1 = /** @type {(inputs: Nav_Mostplayed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सबसे ज़्यादा खेले गए`)
};

const th_nav_mostplayed1 = /** @type {(inputs: Nav_Mostplayed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เล่นมากที่สุด`)
};

const ja_nav_mostplayed1 = /** @type {(inputs: Nav_Mostplayed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最もプレイされた`)
};

const zh_cn2_nav_mostplayed1 = /** @type {(inputs: Nav_Mostplayed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`热门游玩`)
};

const zh_hant1_nav_mostplayed1 = /** @type {(inputs: Nav_Mostplayed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`熱門遊玩`)
};

const ko_nav_mostplayed1 = /** @type {(inputs: Nav_Mostplayed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`최다 플레이`)
};

/**
* | output |
* | --- |
* | "Most Played" |
*
* @param {Nav_Mostplayed1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const nav_mostplayed1 = /** @type {((inputs?: Nav_Mostplayed1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Mostplayed1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_nav_mostplayed1(inputs)
	if (locale === "ms") return ms_nav_mostplayed1(inputs)
	if (locale === "da") return da_nav_mostplayed1(inputs)
	if (locale === "de") return de_nav_mostplayed1(inputs)
	if (locale === "en-US") return en_us2_nav_mostplayed1(inputs)
	if (locale === "es-ES") return es_es2_nav_mostplayed1(inputs)
	if (locale === "es-MX") return es_mx2_nav_mostplayed1(inputs)
	if (locale === "fil") return fil_nav_mostplayed1(inputs)
	if (locale === "fr") return fr_nav_mostplayed1(inputs)
	if (locale === "it") return it_nav_mostplayed1(inputs)
	if (locale === "hu") return hu_nav_mostplayed1(inputs)
	if (locale === "nl") return nl_nav_mostplayed1(inputs)
	if (locale === "no") return no_nav_mostplayed1(inputs)
	if (locale === "pl") return pl_nav_mostplayed1(inputs)
	if (locale === "pt-BR") return pt_br2_nav_mostplayed1(inputs)
	if (locale === "pt") return pt_nav_mostplayed1(inputs)
	if (locale === "ro") return ro_nav_mostplayed1(inputs)
	if (locale === "fi") return fi_nav_mostplayed1(inputs)
	if (locale === "sv") return sv_nav_mostplayed1(inputs)
	if (locale === "vi") return vi_nav_mostplayed1(inputs)
	if (locale === "tr") return tr_nav_mostplayed1(inputs)
	if (locale === "cs") return cs_nav_mostplayed1(inputs)
	if (locale === "bg") return bg_nav_mostplayed1(inputs)
	if (locale === "ru") return ru_nav_mostplayed1(inputs)
	if (locale === "uk") return uk_nav_mostplayed1(inputs)
	if (locale === "ar") return ar_nav_mostplayed1(inputs)
	if (locale === "hi") return hi_nav_mostplayed1(inputs)
	if (locale === "th") return th_nav_mostplayed1(inputs)
	if (locale === "ja") return ja_nav_mostplayed1(inputs)
	if (locale === "zh-CN") return zh_cn2_nav_mostplayed1(inputs)
	if (locale === "zh-Hant") return zh_hant1_nav_mostplayed1(inputs)
	return ko_nav_mostplayed1(inputs)
});
export { nav_mostplayed1 as "nav.mostPlayed" }